const OPENAI_YAML_FILENAME = "openai.yaml";

export const isOpenaiYamlFilePath = (path: string): boolean =>
  path.split("/").pop()?.toLowerCase() === OPENAI_YAML_FILENAME;
